import { render } from "./DatabaseForm.vue?vue&type=template&id=0d302cbc&scoped=true"
import script from "./DatabaseForm.vue?vue&type=script&lang=js"
export * from "./DatabaseForm.vue?vue&type=script&lang=js"

import "./DatabaseForm.vue?vue&type=style&index=0&id=0d302cbc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d302cbc"]])

export default __exports__